import 'client-only'

import * as Fingerprint from '@fingerprint/agent'

import { FEATURES, MODULES } from '@src/quince-site-common/src/constants/template-info'
import { captureException } from '@src/quince-site-common/src/utils/sentryUtil/sentryUtil'
import { getSessionStorage } from '@src/utils/enhancedSessionStorage'
import { getStorage } from '@src/utils/enhancedStorage'

import type { GetResult } from '@fingerprint/agent'

export type FingerprintVisitorData = Pick<GetResult, 'visitor_id' | 'event_id' | 'suspect_score' | 'cache_hit'>

export const FINGERPRINT_STORAGE_KEY = 'fp_visitor_details'
export const LS_TTL_MS = 24 * 60 * 60 * 1000

export interface StoredEntry {
  result: FingerprintVisitorData
  expiresAt: number
}

export function reportFingerprintError(err: unknown): void {
  const extraInfo: Record<string, unknown> = {}
  if (Fingerprint.isFingerprintError(err)) {
    extraInfo.code = err.code
    extraInfo.event_id = err.event_id
  }
  captureException(err, {
    module: MODULES.TRACKING,
    feature: FEATURES.FINGERPRINTING,
    extraInfo,
  })
}

export function getVisitorDetailsFromLocalStorage(): FingerprintVisitorData | null {
  const entry = getStorage().getItemJSON<StoredEntry>(FINGERPRINT_STORAGE_KEY)
  if (!entry) return null
  if (Date.now() > entry.expiresAt) {
    getStorage().removeItem(FINGERPRINT_STORAGE_KEY)
    return null
  }
  return entry.result
}

export function getVisitorDetailsFromSessionStorage(): FingerprintVisitorData | null {
  const entry = getSessionStorage().getItemJSON<StoredEntry>(FINGERPRINT_STORAGE_KEY)
  if (!entry) return null
  if (Date.now() > entry.expiresAt) {
    getSessionStorage().removeItem(FINGERPRINT_STORAGE_KEY)
    return null
  }
  return entry.result
}

export function saveToStorage(result: GetResult, lsTtlMs: number): FingerprintVisitorData {
  const { visitor_id, event_id, suspect_score, cache_hit } = result
  const data: FingerprintVisitorData = { visitor_id, event_id, suspect_score, cache_hit }
  const entry: StoredEntry = { result: data, expiresAt: Date.now() + lsTtlMs }
  getStorage().setItemJSON(FINGERPRINT_STORAGE_KEY, entry)
  getSessionStorage().setItemJSON(FINGERPRINT_STORAGE_KEY, entry)
  return data
}
